<div class="gb-dialog-header">
  <h1 translate="PRESENTER.TEAM_SCORING_TOOLS.FILTER_TEAMS.TITLE"></h1>
  <button mat-icon-button type="button" (click)="cancel()">
    <gb-icon icon="close"></gb-icon>
  </button>
</div>

<div class="gb-dialog-content">
  @if (vm$ | async; as vm) {
    @if (!vm.loaded && vm.teams.length === 0) {
      <div class="loading">
        <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
      </div>
    } @else {
      <div class="hint" translate="PRESENTER.TEAM_SCORING_TOOLS.FILTER_TEAMS.HINT"></div>

      <div class="teams-table" #teamsTableContainer>
        <gb-table
          [inDialog]="true"
          [enableSelect]="true"
          [tableData$]="tableData$"
          [displayedColumns$]="displayedColumns$"
          [loaded$]="loaded$"
          [totalItemCount]="vm.count"
          [selectedItems]="selectedTeams"
          (checkboxChangeEvent)="onSelectedTeamsChange($event)"
        ></gb-table>

        @if (isLoadingMore && !vm.loaded) {
          <div class="loading-more">
            <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
          </div>
        }
      </div>
    }
  }
</div>

<div class="gb-dialog-actions-container gb-flex-button-container">
  <button mat-stroked-button type="button" (click)="cancel()">
    {{ 'CANCEL' | translate }}
  </button>
  <button mat-flat-button type="button" (click)="apply()">
    {{ 'APPLY' | translate }}
  </button>
</div>
